<div class="mt-2">
	<app-paging-search-bar [parentApi]="getParentMethod()" [centered]="false"></app-paging-search-bar>
	<div *ngIf="items.length > 0">
		<table *ngIf="!loading && itemsToShow.length > 0" class="cp-std-table cp-auto-width">
			<thead>
				<tr app-column-headings [parentApi]="getParentMethod()" [columnDefs]="columnDefs" [fieldsToShow]="fieldsToShow"
					[displayOptions]="displayOptions">
				</tr>
				<!-- <tr>
					<th *ngFor="let cd of columnDefs" (click)="setSortBy(cd.field)" class="text-center cp-pre-text cp-pointer"
						[ngClass]="{ 'cp-sort-column-header': displayOptions.sortBy === cd.field, 'cp-icon-header': !!cd.icon }"
						[hidden]="!fieldsToShow.includes(cd.field)">
						<span *ngIf="cd.label" [innerHTML]="cd.label"
							[ngClass]="{'fst-italic': displayOptions.sortBy === cd.field && displayOptions.sortDir === 'desc'}"
							[ngbTooltip]="cd.toolTip ? cd.toolTip : ''"></span>
						<fa-icon *ngIf="cd.icon" [icon]="cd.icon" [ngbTooltip]="cd.toolTip ? cd.toolTip : ''"></fa-icon>
					</th>
				</tr> -->
			</thead>
			<tbody *ngIf="!loading && itemsToShow?.length > 0">
				<tr *ngFor="let item of itemsToShow" [ngClass]="{'text-danger': item.enabled === 0 && !slt.isSpecialKey(item)}">

					<td [hidden]="!fieldsToShow.includes('__delete_button')" class="text-nowrap">
						<fa-icon [icon]="['fas', 'trash-alt']" class="text-danger" size="sm" placement="end"
							ngbTooltip="Remove Key from User Account" (click)="deleteUserKey(item['__user_id'], item.id)">
						</fa-icon>
					</td>

					<td [hidden]="!fieldsToShow.includes('enabled')" class="cp-icon-cell">
						<fa-icon *ngIf="item.enabled === 1" [icon]="['fas', 'power-off']" size="sm" class="text-success"
							ngbTooltip="Enabled" placement="end">
						</fa-icon>
						<fa-icon *ngIf="item.enabled === 0 && !slt.isSpecialKey(item)" [icon]="['fas', 'ban']" size="sm" class="text-danger"
							ngbTooltip="Disabled" placement="end"></fa-icon>
					</td>

					<td [hidden]="!fieldsToShow.includes('__user_label')" class="cp-chopped-col-medium">
						<span class="cp-85" [ngbTooltip]="item['__user_label']">
							{{ item['__user_label'] }}
						</span>
					</td>
					<td [hidden]="!fieldsToShow.includes('__key_label')" class="cp-chopped-col-medium">
						<span class="cp-85" [ngbTooltip]="item['__key_label']">
							{{ item['__key_label'] }}
						</span>
					</td>

					<td [hidden]="!fieldsToShow.includes('created_at')" class="text-nowrap">
						{{ item.created_at | date: ac.tableDateFmt }}
					</td>

					<td [hidden]="!fieldsToShow.includes('__expires_at')" class="text-nowrap"
						[ngClass]="{'text-danger': item['__expires_at'] && mt.hasExpired(item['__expires_at']) }">
						{{ item['__expires_at_display'] }}
					</td>

					<td [hidden]="!fieldsToShow.includes('org_name')" class="cp-chopped-col-medium">
						<span class="cp-75" [ngbTooltip]="item.org_name">
							{{ item.org_name }}
						</span>
					</td>

					<td [hidden]="!fieldsToShow.includes('info')" class="cp-chopped-col-medium">
						<span class="cp-75" [ngbTooltip]="item.info">
							{{ item.info }}
						</span>
						<fa-icon *ngIf="item.opportunity_id && item.opportunity_id.length > 3" [icon]="['fab', 'salesforce']"
							ngbTooltip="Has Salesforce Opportunity ID"></fa-icon>
					</td>

					<td [hidden]="!fieldsToShow.includes('__niceProduct')" class="text-center"
						[ngClass]="!showFullProduct?'cp-icon-cell':''">
						<span *ngIf="!showFullProduct" [ngbTooltip]="item['__niceProduct']">
							{{ slt.licenseProductAcronym(item['__niceProduct']) }}
						</span>
						<span *ngIf="showFullProduct">
							{{ item['__niceProduct'] }}
						</span>
					</td>

					<td [hidden]="!fieldsToShow.includes('type')" class="text-center" [ngClass]="!showFullType?'cp-icon-cell':''">
						<span *ngIf="!showFullType" [ngbTooltip]="tt.capitalizeFirstLetter(item.type)" [class]="'cp-key-type-' + item.type">
							{{ item.type | acronym: true }}
						</span>
						<span *ngIf="showFullType" [class]="'cp-key-type-' + item.type">
							{{ tt.capitalizeFirstLetter(item.type) }}
						</span>
					</td>

					<td [hidden]="!fieldsToShow.includes('key')" class="text-nowrap">
						<fa-icon *ngIf="item['__warnings'] && item['__warnings'].length !== 0" [icon]="['fas', 'exclamation-triangle']"
							class="text-warning cp-110"
							ngbTooltip="Key has Warnings - show and view the column or view the key for details">
						</fa-icon>
						<fa-icon *ngIf="item['__irregularities'] && item['__irregularities'] !== ''" [icon]="['fas', 'info-circle']"
							class="text-warning cp-110"
							ngbTooltip="Key has Meter Irregularities - show and view the column or view the key for details">
						</fa-icon>
						<a *ngIf="addPopovers" [routerLink]="item['__route']" [ngbPopover]="popupContent" popoverClass="cp-popover-std"
							triggers="mouseenter:mouseleave" container="body" class="cp-key cp-85">
							{{ item.key }}</a>
						<a *ngIf="!addPopovers" [routerLink]="item['__route']" class="cp-key cp-85">
							{{ item.key }}</a>
						<fa-icon [icon]="['fas', 'copy']" class="cp-pointer ms-1" ngxClipboard (click)="copyToClipboardAlert(item.key)"
							[cbContent]="item.key" ngbTooltip="Copy to Clipboard"></fa-icon>
					</td>

					<td [hidden]="!fieldsToShow.includes('count')" class="text-center">
						<span *ngIf="!showExpandedActivations" [ngbTooltip]="item.count">
							{{ tt.formatCount(item.count) }}
						</span>
						<span *ngIf="showExpandedActivations" [ngbTooltip]="tt.formatNumber(item.count) + '/' + tt.formatNumber(item.max)">
							{{ tt.formatCount(item.count) }} / {{ tt.formatCount(item.max) }}
						</span>
					</td>

					<td [hidden]="!fieldsToShow.includes('__active_hostids')" class="cp-icon-cell text-center">
						{{ item['__active_hostids'] | number}}
					</td>

					<td [hidden]="!fieldsToShow.includes('num_users')" class="cp-icon-cell text-center">
						{{ item.num_users | number}}
					</td>

					<td [hidden]="!fieldsToShow.includes('__meter_status')" class="cp-icon-cell text-center">
						<fa-icon *ngIf="item['__meter_status'] !== ''" [icon]="ac.meterIcon" size="sm" placement="start"
							[ngbTooltip]="item['__meter_status']" [class]="item['__meter_status_class']">
						</fa-icon>
					</td>

					<td [hidden]="!fieldsToShow.includes('__protocol_status')" class="cp-icon-cell text-center">
						<fa-icon *ngIf="item['__protocol_status'] !== ''" [icon]="ac.protocolIcon" size="sm" placement="start"
							[ngbTooltip]="item['__protocol_status']" [class]="item['__protocol_status_class']">
						</fa-icon>
					</td>

					<td [hidden]="!fieldsToShow.includes('__last_touched_by')" class="text-nowrap text-center">
						<span class="cp-75" [ngbTooltip]="item['__last_touched_by']">
							{{ item['__last_touched_by'] | acronym }}
						</span>
					</td>

					<td [hidden]="!fieldsToShow.includes('__sales_engineer')" class="text-nowrap text-center">
						<span class="cp-75" [ngbTooltip]="item['__sales_engineer']">
							{{ item['__sales_engineer'] | acronym }}
						</span>
					</td>

					<td [hidden]="!fieldsToShow.includes('__tam')" class="text-nowrap text-center">
						<span class="cp-75" [ngbTooltip]="item['__tam']">
							{{ item['__tam'] | acronym}}
						</span>
					</td>

					<td [hidden]="!fieldsToShow.includes('__sa')" class="text-nowrap text-center">
						<span class="cp-75" [ngbTooltip]="item['__sa']">
							{{ item['__sa'] | acronym }}
						</span>
					</td>

					<td [hidden]="!fieldsToShow.includes('__comm_type')" class="text-nowrap text-center">
						<span class="cp-75" [ngbTooltip]="item['__comm_type']">
							{{ item['__comm_type_acronym'] }}
						</span>
					</td>

					<td [hidden]="!fieldsToShow.includes('__snoozes')" class="cp-icon-cell text-center">
						<fa-icon *ngIf="item['__snoozes'] && item['__snoozes'] !== ''" [icon]="['fas', 'snooze']" size="sm"
							placement="start" [ngbTooltip]="item['__snoozes']">
						</fa-icon>
					</td>

					<td [hidden]="!fieldsToShow.includes('__warnings')">
						<span class="cp-75">
							{{ item['__warnings'].join('\n') }}
						</span>
					</td>

					<td [hidden]="!fieldsToShow.includes('__irregularities')">
						<span class="cp-75">
							{{ item['__irregularities'] }}
						</span>
					</td>

					<ng-template #popupContent>
						<app-card-key [object]="item" [forBasic]="!staffMode"></app-card-key>
					</ng-template>
				</tr>
			</tbody>
		</table>
	</div>
	<app-paging-bar [parentApi]="getParentMethod()" [pageNum]="displayOptions.pageNum" [pagingOptions]="pagingOptions"
		[centered]="false"></app-paging-bar>
</div>